<template>
  <div class="dsf_login">
    <div class="close-btn">
      <dsf-icon name="guanbi2" @click="$root.close()"></dsf-icon>
    </div>
    <div class="dsf_login_inner" :style="{ width: boxWidth }">
      <el-tabs :tab-position="tabPosition">
        <el-tab-pane label="账号登录">
          <textLogin
            :sourceUrl="sourceUrl"
            :nameHolder="nameHolder"
            :pwdHolder="pwdHolder"
            :codeHolder="codeHolder"
            :toUrl="toUrl"
            :login-success="_loginSuccess"
            :login-fail="_loginFail"
            @changePassword="changePassword"
            @toRegister="toRegister"
          />
        </el-tab-pane>
        <el-tab-pane label="验证码登录">
          <codeLogin :login-success="_loginSuccess" :login-fail="_loginFail" @changePassword="changePassword" @toRegister="toRegister" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { textLogin, codeLogin } from "../../base/login";
export default dsf.component({
  name: "DsfNcDialogLogin",
  ctrlCaption: "登录",
  mixins: [$mixins.control],
  props: {
    title: {
      type: String,
      default: "登录",
    },
    moreUrl: {
      type: String,
      default: "/",
    },
    boxWidth: {
      type: String,
      default: "300px",
    },
    sourceUrl: {
      type: String,
      default: "/nc/login/login",
    },
    nameHolder: {
      type: String,
      default: "请输入账号",
    },
    pwdHolder: {
      type: String,
      default: "请输入密码",
    },
    codeHolder: {
      type: String,
      default: "动态验证码",
    },
    toUrl: {
      type: String,
      default: "",
    },
    loginSuccess: {
      type: Function,
      required: false,
    },
    loginFail: {
      type: Function,
      required: false,
    },
  },
  created() {},
  components: {
    textLogin,
    codeLogin,
  },
  methods: {
    yes() {
      return new Promise(resolve => {
        this.resolve = resolve;
      });
    },
    _loginSuccess() {
      this.resolve?.(true);
      this.loginSuccess?.();
    },
    _loginFail() {
      this.resolve?.(false);
      this.loginFail?.();
    },
    changePassword() {
      const path = dsf.config.setting_public_login_forget_password;
      path && dsf.layer.openWindow(path);
    },
    toRegister() {
      const path = dsf.config.setting_public_login_register;
      path && dsf.layer.openWindow(path);
    },
  },
});
</script>
